module.exports = __webpack_public_path__ + "img/autoconta.7e1192cb.jpg";